import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  loading = false;

  setLoading( status ) {
    this.loading = status;
  }

  getLoading() {
    return this.loading;
  }

}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/app/app.component.ts